var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReportDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.336,
    height: 18,
    viewBox: "0 0 17.336 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_540",
    "data-name": "Union 540",
    d: "M17630.309,8952a2.3,2.3,0,0,1-2.307-2.3v-13.4a2.306,2.306,0,0,1,2.307-2.3h12.721a2.317,2.317,0,0,1,2.309,2.3v13.4a2.313,2.313,0,0,1-2.309,2.3Zm-1.051-15.7v13.4a1.049,1.049,0,0,0,1.051,1.047h12.721a1.049,1.049,0,0,0,1.051-1.047v-13.4a1.05,1.05,0,0,0-1.051-1.051h-12.721A1.05,1.05,0,0,0,17629.258,8936.3Zm3.221,12.257a.627.627,0,0,1,0-1.255h8.379a.627.627,0,0,1,0,1.255Zm0-3.348a.629.629,0,0,1,0-1.259h5.865a.629.629,0,0,1,0,1.259Zm.258-3.741a.621.621,0,0,1,.135-.684l2.514-2.509a.625.625,0,0,1,.893,0l1.188,1.19,2.072-2.414a.632.632,0,1,1,.961.82l-2.518,2.931a.643.643,0,0,1-.453.217.582.582,0,0,1-.463-.182l-1.236-1.236-2.07,2.075a.628.628,0,0,1-1.021-.209Z",
    transform: "translate(-17628.002 -8934.001)",
    fill: "#f8f8f8",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportDark);
export default __webpack_public_path__ + "static/media/icon-report_dark.a40cfef67763148539f303d1a8deb71f.svg";
export { ForwardRef as ReactComponent };